module.exports = __webpack_public_path__ + "images/般蓝pr长图_07.jpg?v=da4f881c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图_07.jpg
 ** module id = 184
 ** module chunks = 1 2
 **/